// Must stay the first import: starts Sentry before any other module runs.
import "@/instrument";
import "@/styles/globals.css";

import { IconContext } from "@phosphor-icons/react";
import { ErrorBoundary } from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "@/App";
import { ErrorFallback } from "@/components/error-fallback";
import { queryClient } from "@/lib/api";
import { upgradeFavicon } from "@/lib/brand-assets";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

upgradeFavicon();

createRoot(rootElement).render(
  <StrictMode>
    {/* Reports render crashes to Sentry (when enabled) and shows a fallback
        instead of a blank page either way. */}
    <ErrorBoundary fallback={<ErrorFallback />}>
      {/* Phosphor, Regular weight only, 20px beside text, and hidden from
          assistive tech: the words beside an icon carry its meaning. */}
      <IconContext.Provider value={{ size: 20, weight: "regular", "aria-hidden": true }}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </IconContext.Provider>
    </ErrorBoundary>
  </StrictMode>,
);
